(function ($, Global) {
    var urlParams = new UrlParams();
    // Nouveau composant JS pour les filtres de la page recherche
    function FiltersComponentV2() {
        // Déclaration class objet
    }

    FiltersComponentV2.prototype.initEvents = function () {
		this.publishers();
		this.subscribers();
	}

    FiltersComponentV2.prototype.publishers = function () {
        var self = this;

        $(document).ready(function () {
			$('.formFilters [type="hidden"]').each(function () {
				var keyName = $(this).attr('name');
                var value = $(this).attr('value');

				urlParams.setParam(keyName, value);
            });

            if (!urlParams.getPathName().includes('free') && (urlParams.getParam('Country') || urlParams.getParam('Region') || urlParams.getParam('Theme') || urlParams.getParam('Secteur') || urlParams.getParam('Section') || urlParams.getParam('Publication'))) {
                $.Topic('filters-changed').publish();
                var paramList = ['Section', 'Secteur', 'Publication', 'Region', 'Theme'];
                for (var i = 0; i < paramList.length;i++) {
                    self.setFilterLists(paramList[i]);                   
                }
            }
		});

		$(document).on('click', '#btnResetFiltres', function (e) {
            var newUrlParams = new UrlParams();
            var params = newUrlParams.getParams();

            newUrlParams.resetParams();
            if (params.sqe) {
                newUrlParams.setParam('sqe', params.sqe);
			}

			document.location.reload(true);
        });

        $(document).on('click', '.results-title-container .remove-filter-button', function (e) {
            self.deactiveFilter(e, false)
        })

        $(document).on('click', '#filtersActiveMobile .remove-filter-button', function (e) {
            self.deactiveFilter(e, true)
        })

        $(document).on('change', '.page-recherche .formFilters input, .formFilters select, input[name="Subscription"]', function () {
            if ($(this).attr('id')!='All') {
                $.Topic('filters-change').publish(this);
            }
        });

        $(document).on('change', '.page-recherche .formFiltersMobile input, .formFiltersMobile select, input[name="Subscription"]', function () {
            if ($(this).attr('id') != 'All_mobile') {
                $.Topic('filters-change').publish(this);
            }
        });

		$(document).on('changeDate', '.sidenav .formFilters .datepicker', function () {
			$.Topic('filters-change').publish(this);
        });

        $(document).on('click', '.formFilters .dropdown-menu', function (e) {
            e.stopPropagation();
        });

        $('.page-liste').on('change', '.formFilters select', function (e) {
            $.Topic('filters-change').publish(this);
            $.Topic('filters-changed').publish();
        })

        $(document).on('click', '.formFiltersMobile .more-sector', function (e) {
            e.preventDefault();
            $(document).find('.sector-list').addClass('show-more');
            $(this).addClass('d-none');
        });

        $(document).on('change', '.formFilters #All', function (e) {
            self.setAllPubli(this,false)
        });

        $(document).on('change', '.formFiltersMobile #All_mobile', function (e) {
            self.setAllPubli(this, true);
        });

        $(document).on('click', '.veille-creation button', function (e) {
            e.preventDefault();
        });
	}

    FiltersComponentV2.prototype.subscribers = function () {
		var self = this;

        $.Topic('filters-change').subscribe(function (el) {
            var $el = $(el);
            var $parent = $el.closest('.formFilters');
			var keyName = $el.attr('name');
            var value = $el.val();

            if ($el.data('type-search') === "region") {
                $('select[name="Country"]').each(function () {
                    $(this).val($(this).find("option:first").val());
                });
                urlParams.setParam('Country', '');
            }

            self.setParamCheckbox(el, keyName, value);

			if (keyName == 'Date') {
				$('.date-perso-content')[value == 'Custom' ? 'removeClass' : 'addClass']('hidden');
			}

			if (keyName == 'Country' && $parent.find('[name="CountryAIBehavior"]').exists()) {
				return Global.location.replace($el.val());
			}

            if (keyName == 'Publication') $.Topic('filters-changed').publish();
        });

        $.Topic('select-all-publi').subscribe(function (el, val) {
            self.selectAll(el,val)
        })
    }

    FiltersComponentV2.prototype.selectAll = function (el, val) {
        var self = this;
        $(el).prop('checked', val)
        var keyName = $(el).attr('name');
        var paramValue = urlParams.getParam(keyName) || '';
        var value = $(el).val()
        var template = self.getBadgeTemplate(value)
        if ($(el).is(':checked')) {
            if (!paramValue.includes(value) && value != 'All') {
                paramValue += ',' + value;
                $('.page #filtersActive').append(template);
                $('.page #filtersActiveMobile').append(template);
            }
        } else {
            paramValue = paramValue.replace(',' + value, '');
            $('.page #filtersActive div').remove('.badge[data-badge-id="' + value+'"]');
            $('.page #filtersActiveMobile div').remove('.badge[data-badge-id="' + value +'"]');
        }
        return urlParams.setParam(keyName, paramValue);
    }

    FiltersComponentV2.prototype.getBadgeTemplate = function (value) {
        if (value == null || value == '') return '';
        var $el = $('.formFilters input[id="' + value + '"]');

        return '<div class="badge" data-badge-id="' + value + '">' + $el.attr("data-search") + '<span data-input-id="' + value + '" class="remove-filter-button icon icon-112"><span/></div >';   
    }

    FiltersComponentV2.prototype.setAllPubli = function (el,isMobile) {
        var val = $(el).is(':checked');
        var className = isMobile ? '.publication-filter-available-mobile' : '.publication-filter-available';
        $(className).find('input').each(function () {
            $.Topic('select-all-publi').publish(this, val);
        });
        $.Topic('filters-changed').publish();
    }

    FiltersComponentV2.prototype.setParamCheckbox = function (el, keyName, value) {
        var self = this;

        var $el = $(el);

        if ($el.attr('type').toLowerCase() != 'checkbox') return urlParams.setParam(keyName, value);
        
        if ($el.val() == 'on') {
            urlParams.setParam(keyName, $el.is(':checked') ? 'true' : 'false');
        } else {
            var paramValue = urlParams.getParam(keyName) || '';
            var template = self.getBadgeTemplate(value)

            if ($el.is(':checked')) {
                paramValue += ',' + value;
                $('.page #filtersActive').append(template);
                $('.page #filtersActiveMobile').append(template);
            } else {
                paramValue = paramValue.replace(',' + value, '');
                $('.page #filtersActive div').remove('.badge[data-badge-id="' + value + '"]');
                $('.page #filtersActiveMobile div').remove('.badge[data-badge-id="' + value + '"]');
                $('.page #filtersActive div').remove('#' + value);
                $('.page #filtersActiveMobile div').remove('#' + value);
            }
            urlParams.setParam(keyName, paramValue);
            if (keyName == 'Publication') {
                $('.formFilters #All').checked(paramValue.split(',').length == 4)
                $('.formFiltersMobile #All_mobile').checked(paramValue.split(',').length == 4)
            }
        }
        var count = $el.closest('.dropdown-menu').find('input:checked').length;
        $('span.' + keyName.toLowerCase() + '-count').html(count > 0 ? '(' + count + ')' : '');
    }

    FiltersComponentV2.prototype.setFilterLists = function (paramList) {
        var self = this;

        var paramValue = urlParams.getParam(paramList) || '';
        for (var j = 0; j < paramValue.split(',').length; j++) {
            var value = paramValue.split(',')[j];
            var template = self.getBadgeTemplate(value)
            $('.page #filtersActive').append(template);
            $('.page #filtersActiveMobile').append(template);
        }

        if ($('.dropdown[id="' + paramList + '"]').exists()) {
            var count = paramValue.split(',').length - 1;
            $('span.' + paramList.toLowerCase() + '-count').html(count > 0 ? '(' + count + ')' : '');
        }
    }
    FiltersComponentV2.prototype.deactiveFilter = function (event, isMobile) {
        var name = $(event.target).data('input-id');
        var $el = $('.formFilters input[id="' + name + '"]')
        if (isMobile) $el = $('.formFiltersMobile input[id="' + name + '_mobile"]')
        var wrapper = '.page #filtersActive div';
        if (isMobile) wrapper = '.page #filtersActiveMobile div';
        $el.prop('checked', false);
        $.Topic('filters-change').publish($el);        
        $(wrapper).remove('.badge[data-badge-id="' + name +'"]');
        $.Topic('filters-changed').publish();
    }
    Global.FiltersComponentV2 = FiltersComponentV2;
}(jQuery, window));